module.exports = __webpack_public_path__ + "static/media/(LH)-04-Capim-Dourado-bijuterias.c6e562cd.jpg";